// extracted by mini-css-extract-plugin
module.exports = {"termsOfServiceContainer":"TermsOfService_termsOfServiceContainer__1-V4g","iframe":"TermsOfService_iframe__1yV5q","accept_container":"TermsOfService_accept_container__2vNXu"};